import React, { useState } from "react";
import { CreateNewSurvey } from "../../../services/SurveyService"; 
import NormalAlert from "../../AlertComponent/NormalAlert";
import { Navigate, useNavigate } from "react-router-dom";
const CreateSurvey = () => {
  const [alert, setAlert] = useState(null);
const navigate=useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const surveyName = formData.get("surveyName");
    const surveyDescription = formData.get("surveyDescription");
    try {
      const response = await CreateNewSurvey(surveyName, surveyDescription);
      if(response){
        console.log(response)
        setAlert({ type: "success", message: "Survey created successfully!" });
          setTimeout(() => navigate(`/Dashboard/CreateQuestion/${response.data.assessmentUID}`), 1500);
        }
      e.target.reset();
    } catch (error) {
      console.error(error);
      setAlert({
        type: "danger",
        message: error?.response?.data?.message || "Something went wrong",
      });
    }
  };

  return (
    <div className="min-vh-100 bg-light py-5">
      <div className="container pt-5">
        <div className="mx-auto" style={{ width: "520px" }}>
          <div className="text-center mb-5">
            <div
              className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle mb-3"
              style={{ width: "64px", height: "64px" }}
            >
              <svg
                className="text-white"
                width="32"
                height="32"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <h1 className="h3 fw-bold text-dark">Create Survey</h1>
            <p className="text-muted">Design your survey and gather valuable insights</p>
          </div>

          {alert && <NormalAlert type={alert.type} message={alert.message} onClose={() => setAlert(null)}/>}

          <div className="card shadow-sm">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                {/* Survey Name */}
                <div className="mb-4">
                  <label htmlFor="surveyName" className="form-label fw-semibold">
                    Survey Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="surveyName"
                    name="surveyName"
                    className="form-control"
                    placeholder="Enter your survey title"
                    required
                  />
                </div>

                {/* Survey Description */}
                <div className="mb-4">
                  <label htmlFor="surveyDescription" className="form-label fw-semibold">
                    Survey Description <span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="surveyDescription"
                    name="surveyDescription"
                    className="form-control"
                    rows="4"
                    placeholder="Describe the purpose and goals of your survey"
                    required
                  ></textarea>
                </div>

                {/* Submit Button */}
                <div className="d-grid">
                  <button type="submit" className="btn btn-primary">
                    Create Survey
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSurvey;
